import { twMerge } from "tailwind-merge";
import { FC } from "react";
import { MdPerson, MdWork, MdAllInclusive } from "react-icons/md";
import { NavLink, Outlet } from "react-router";
import { CardBack, CardBackProps } from "./components/PlayingCard";

interface CardLinkProps extends CardBackProps {
  to: string;
  title: string;
}

const CardLink: FC<CardLinkProps> = ({ to, title, icon, className }) => (
  <NavLink
    to={to}
    className={({ isActive }) =>
      twMerge(
        className,
        "flex transition-transform",
        isActive ? "md:translate-y-12 translate-y-16" : "hover:translate-y-6 hover:z-40"
      )
    }
    title={title}
  >
    <CardBack title={title} icon={icon} className="max-w-full" />
  </NavLink>
);

export const Shell = () => (
  <div className="absolute inset-0 flex flex-col">
    <header className="relative h-32">
      <nav className="h-full md:max-w-200 mx-auto grid grid-cols-3 justify-end px-2 md:px-6 -mt-82 md:-mt-64 gap-6">
        <CardLink
          to="/home"
          title="who am I?"
          icon={MdPerson}
          className="z-30 hover:z-40 max-w-[50vw] md:max-w-96 bottom-0 left-0"
        />
        <CardLink
          to="/work"
          title="work experiences"
          icon={MdWork}
          className="z-20 max-w-[50vw] md:max-w-96 bottom-0 left-[25vw] justify-center"
        />
        <CardLink
          to="/other"
          title="other projects"
          icon={MdAllInclusive}
          className="z-10 max-w-[50vw] md:max-w-96 bottom-0 right-0 justify-end"
        />
      </nav>
    </header>
    <main className="relative flex justify-center items-center w-full h-[calc(100%-8rem)] overflow-hidden">
      <Outlet />
    </main>
  </div>
);
